/* @flow */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import type TypeForm from 'forms/_.extend';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';

import endpoints from 'api/endpoints';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  costCenter: Object,
  form: TypeForm,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class AssignProjectsForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, costCenter, form }: TypeProps = this.props;

    const getChildData: Function = (child: string, val: string) => {
      return typeof costCenter[child] === 'undefined' ? null : costCenter[child][val];
    };

    const costCenterDetails: Array<Array> = [
      [
        t('general:trading_account'),
        `${getChildData('trading_account', 'name')} ${getChildData(
          'trading_account',
          'account_no'
        )}`,
      ],
      [t('general:cost_centers.labels.code'), costCenter.code],
      [t('general:cost_centers.labels.name'), costCenter.name],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:cost_centers.labels.details')}
          >
            <ActionDrawerTable data={costCenterDetails} />
          </ActionDrawerBlock>
          <ElectroCheckList
            field={form.$('assignProjects.projectIds')}
            type="check"
            heading={form.$('assignProjects').label}
            endpoint={`${endpoints.projects}?search=account:${getChildData(
              'trading_account',
              'id'
            )}`}
            enableSearch={true}
            searchKeys={['code', 'name']}
            exclude={costCenter.projects.map((cc: Object) => cc.id)}
            customResponse={(resp: Object) => {
              return resp.data;
            }}
            primaryLiteral={(item: Object) => {
              return `${item.code} - ${item.name}`;
            }}
          />
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.assign_projects')} />
      </React.Fragment>
    );
  }
}
